import {Component, Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-poll-choice-footer',
  templateUrl: './poll-choice-footer.component.html',
  styleUrls: ['./poll-choice-footer.component.less', '../../shared/common.less'],
})

export class PollChoiceFooterComponent {
  @Input() isMobile: boolean;
  @Output() selected = new EventEmitter<string>();

  actionVote() {
    this.selected.emit('selected');
  }

}
